var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.jobApplication.permission_granted
    ? _c(
        "div",
        { staticClass: "background-verification p-4" },
        [
          _c(
            "form",
            { attrs: { method: "post" }, on: { submit: _vm.disablePassBtn } },
            [
              _c("input", {
                attrs: { type: "hidden", name: "_csrfToken" },
                domProps: { value: _vm.csrfToken }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "background_verification_status"
                },
                domProps: { value: _vm.background_verification_status }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "send_to_sage" },
                domProps: { value: _vm.send_to_sage }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mb-3" }, [
                _vm.jobApplication.is_background_check_manual &&
                _vm.jobApplication.panel_interview_status === "passed"
                  ? _c("div", [
                      _vm.panelInterviewLogs !== null &&
                      _vm.panelInterviewLogs !== ""
                        ? _c("span", [
                            _vm._v(
                              "\n                    Manual Passed By: " +
                                _vm._s(_vm.panelInterviewLogs.user.first_name) +
                                " " +
                                _vm._s(_vm.panelInterviewLogs.user.last_name) +
                                " - " +
                                _vm._s(
                                  _vm.convertDate(
                                    _vm.panelInterviewLogs.created,
                                    "YYYY-MM-DD HH:mm"
                                  )
                                ) +
                                "\n                "
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "Candidate granted permission for background checks: " +
                      _vm._s(_vm.permissionGrantedDate)
                  )
                ]),
                _vm._v(" "),
                _vm.jobApplication.background_verification_enquiries
                  ? _c(
                      "div",
                      { staticClass: "font-weight-bold mt-3" },
                      _vm._l(
                        _vm.jobApplication.background_verification_enquiries,
                        function(ifact_enquiry, index) {
                          return _c("div", { key: index }, [
                            _c("span", [
                              _vm._v(
                                "Enquiry number: " +
                                  _vm._s(ifact_enquiry.ifacts_enquiry_id) +
                                  " - "
                              )
                            ]),
                            _vm._v(" "),
                            ifact_enquiry.attachment_path_cdn
                              ? _c("span", [
                                  _vm._v("Ifact Check Result: "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "btn btn-sm btn-success",
                                      attrs: {
                                        target: "_blank",
                                        href: ifact_enquiry.attachment_path_cdn
                                      }
                                    },
                                    [_vm._v("Download")]
                                  )
                                ])
                              : _c("span", [
                                  _vm._v("Ifact check is in progress")
                                ])
                          ])
                        }
                      ),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.iFactsMatricCheck &&
                _vm.jobApplication.background_verification_results.length !==
                  _vm.jobApplication.job.requisition.person_specification
                    .background_verification_specs.length &&
                _vm.jobApplication.background_verification_results.length > 0
                  ? _c(
                      "div",
                      { staticClass: "text-danger" },
                      [
                        _vm._v(
                          "\n                This candidate has " +
                            _vm._s(_vm.iFactsMatricCheck.length) +
                            " left background verification to check.\n                "
                        ),
                        _vm._l(_vm.iFactsMatricCheck, function(check) {
                          return _c("div", { key: check }, [
                            _vm._v(_vm._s(check.title))
                          ])
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm._l(_vm.backgroundVerificationResults, function(
                backgroundVerificationResult,
                i
              ) {
                return _c(
                  "div",
                  { key: i, staticClass: "bg-white rounded mb-4" },
                  [
                    _c("div", { staticClass: "grid-x grid-padding-x" }, [
                      _c("div", { staticClass: "cell small-7" }, [
                        _c("div", { staticStyle: { width: "90%" } }, [
                          _c("strong", [
                            _vm._v("Check " + _vm._s(i + 1) + ":")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "mt-2",
                              staticStyle: {
                                "background-color": "#eff3f8",
                                padding: "20px",
                                "border-radius": "2px"
                              }
                            },
                            [
                              backgroundVerificationResult
                                .background_verification_spec.method ===
                              "ifacts"
                                ? _c("div", [
                                    _c("div", [
                                      _c("strong", [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              backgroundVerificationResult
                                                .background_verification_spec
                                                .title
                                            ) +
                                            "\n                                    "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#979797",
                                            "font-size": ".9rem"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                backgroundVerificationResult
                                                  .background_verification_spec
                                                  .method
                                              ) +
                                              "\n                                    "
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "bg-white p-3 mt-2" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "grid-x grid-padding-x"
                                          },
                                          [
                                            _vm._m(0, true),
                                            _vm._v(" "),
                                            !backgroundVerificationResult.result
                                              ? _c(
                                                  "div",
                                                  { staticClass: "cell auto" },
                                                  [
                                                    _vm.jobApplication
                                                      .permission_granted &&
                                                    _vm.isMatricCert(
                                                      backgroundVerificationResult
                                                        .background_verification_spec
                                                        .ifacts_check.check_id
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "cell shrink text-right"
                                                          },
                                                          [
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "button primary mt-0 right",
                                                                attrs: {
                                                                  type:
                                                                    "button",
                                                                  disabled: !_vm.matricCertNumber
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.toggleModal(
                                                                      "confirmModal"
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                    SEND IFACT CHECK\n                                                "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        backgroundVerificationResult.result
                                          ? _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  backgroundVerificationResult
                                                    .result.result_text
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "bg-white p-3 my-3" },
                                      [
                                        _c("label", [_vm._v("Attachment:")]),
                                        _vm._v(" "),
                                        backgroundVerificationResult.result
                                          ? _c("div", [
                                              backgroundVerificationResult
                                                .result.result_file !== null &&
                                              backgroundVerificationResult
                                                .result.result_file !== ""
                                                ? _c("div", [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass: "mb-3",
                                                        attrs: {
                                                          target: "_blank",
                                                          href:
                                                            "" +
                                                            backgroundVerificationResult
                                                              .result
                                                              .result_file_cdn
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                " +
                                                            _vm._s(
                                                              _vm.sliceString(
                                                                backgroundVerificationResult
                                                                  .result
                                                                  .result_file
                                                              )
                                                            ) +
                                                            "\n                                            "
                                                        )
                                                      ]
                                                    ),
                                                    _c("br")
                                                  ])
                                                : _vm._e()
                                            ])
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    backgroundVerificationResult.result
                                      ? _c("div", [
                                          _c("p", [
                                            _vm._v(
                                              "Manual pass/ fail override:"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "grid-x grid-padding-x"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "cell small-5" },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            backgroundVerificationResult
                                                              .result.result,
                                                          expression:
                                                            "backgroundVerificationResult.result.result"
                                                        }
                                                      ],
                                                      staticClass: "border-0",
                                                      on: {
                                                        change: [
                                                          function($event) {
                                                            var $$selectedVal = Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function(o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function(o) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                            _vm.$set(
                                                              backgroundVerificationResult.result,
                                                              "result",
                                                              $event.target
                                                                .multiple
                                                                ? $$selectedVal
                                                                : $$selectedVal[0]
                                                            )
                                                          },
                                                          function($event) {
                                                            return _vm.updateResultStatus(
                                                              backgroundVerificationResult
                                                                .result.id,
                                                              i
                                                            )
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    [
                                                      _c("option"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "pass"
                                                          }
                                                        },
                                                        [_vm._v("Pass")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "fail"
                                                          }
                                                        },
                                                        [_vm._v("Fail")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                : _c("div", [
                                    _c("div", [
                                      _c("strong", [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              backgroundVerificationResult
                                                .background_verification_spec
                                                .title
                                            ) +
                                            "\n                                    "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#979797",
                                            "font-size": ".9rem"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                backgroundVerificationResult
                                                  .background_verification_spec
                                                  .method
                                              ) +
                                              "\n                                    "
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    backgroundVerificationResult.result
                                      ? _c(
                                          "div",
                                          { staticClass: "bg-white p-3 mt-2" },
                                          [
                                            _c("label", [_vm._v("Result:")]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  backgroundVerificationResult
                                                    .result.result_text
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    backgroundVerificationResult.result
                                      ? _c("div", { staticClass: "my-3" }, [
                                          _c("label", [_vm._v("Attachment:")]),
                                          _vm._v(" "),
                                          backgroundVerificationResult.result
                                            .result_file !== null &&
                                          backgroundVerificationResult.result
                                            .result_file !== ""
                                            ? _c("div", [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "mb-3",
                                                    attrs: {
                                                      target: "_blank",
                                                      href:
                                                        "" +
                                                        backgroundVerificationResult
                                                          .result
                                                          .result_file_cdn
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.sliceString(
                                                            backgroundVerificationResult
                                                              .result
                                                              .result_file
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    )
                                                  ]
                                                ),
                                                _c("br")
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "bg-white p-4 d-flex justify-content-between",
                                              staticStyle: {
                                                cursor: "pointer"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.$refs.backgroundVerifUpload[0].click()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "text-muted" },
                                                [_vm._v("Upload File(s)")]
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass:
                                                  "fa-solid fa-upload",
                                                staticStyle: {
                                                  color: "#217FBD"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("input", {
                                                ref: "backgroundVerifUpload",
                                                refInFor: true,
                                                staticClass: "d-none",
                                                attrs: { type: "file" },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.uploadAttachment(
                                                      backgroundVerificationResult
                                                        .result.id,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    backgroundVerificationResult.result
                                      ? _c("div", [
                                          _c("p", [
                                            _vm._v(
                                              "Manual pass/ fail override:"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "grid-x grid-padding-x"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "cell small-5" },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            backgroundVerificationResult
                                                              .result.result,
                                                          expression:
                                                            "backgroundVerificationResult.result.result"
                                                        }
                                                      ],
                                                      staticClass: "border-0",
                                                      on: {
                                                        change: [
                                                          function($event) {
                                                            var $$selectedVal = Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function(o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function(o) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                            _vm.$set(
                                                              backgroundVerificationResult.result,
                                                              "result",
                                                              $event.target
                                                                .multiple
                                                                ? $$selectedVal
                                                                : $$selectedVal[0]
                                                            )
                                                          },
                                                          function($event) {
                                                            return _vm.updateResultStatus(
                                                              backgroundVerificationResult
                                                                .result.id,
                                                              i
                                                            )
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    [
                                                      _c("option"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "pass"
                                                          }
                                                        },
                                                        [_vm._v("Pass")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "fail"
                                                          }
                                                        },
                                                        [_vm._v("Fail")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "cell small-5" }, [
                        _c("label", [_vm._v("Notes:")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              backgroundVerificationResult
                                .background_verification_spec.notes
                            )
                          )
                        ])
                      ])
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _c("hr", { staticStyle: { "max-width": "unset" } }),
              _vm._v(" "),
              _c("strong", [_vm._v("Final Status: ")]),
              _vm._v(" "),
              _c("span", {}, [
                _vm._v(
                  _vm._s(_vm.jobApplication.background_verification_status)
                )
              ]),
              _vm._v(" "),
              _vm.logs !== null && _vm.logs !== ""
                ? _c("span", [
                    _vm._v(
                      "\n             (Updated By " +
                        _vm._s(_vm.logs.user.first_name) +
                        " " +
                        _vm._s(_vm.logs.user.last_name) +
                        " - " +
                        _vm._s(_vm.convertDate(_vm.logs.created)) +
                        ")\n        "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("hr", { staticStyle: { "max-width": "unset" } }),
              _vm._v(" "),
              _c("div", { staticClass: "grid-x grid-padding-x mt-4" }, [
                this.jobApplication.job.requisition.person_specification
                  .ats_type == "agent"
                  ? _c("div", [
                      _c("button", {
                        ref: "passButton",
                        staticClass: "d-none",
                        attrs: { value: "pass", type: "submit" }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button px-5",
                          attrs: {
                            type: "button",
                            disabled: _vm.passBtnDisabled
                          },
                          on: {
                            click: function($event) {
                              return _vm.toggleModal("moveToLoadingOfferModal")
                            }
                          }
                        },
                        [_vm._v("Pass")]
                      )
                    ])
                  : _c("div", [
                      _c("button", {
                        ref: "passButton",
                        staticClass: "d-none",
                        attrs: {
                          value: "pass",
                          name: "background_verification_status"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button px-5",
                          attrs: { type: "button" },
                          on: { click: _vm.passOnly }
                        },
                        [_vm._v("Pass")]
                      )
                    ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell shrink" }, [
                  _c("button", {
                    ref: "failedButton",
                    staticClass: "d-none",
                    attrs: {
                      value: "failed",
                      name: "background_verification_status"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button alert px-5",
                      attrs: {
                        type: "button",
                        name: "background_verification_status",
                        value: "failed"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toggleModal("failModal")
                        }
                      }
                    },
                    [_vm._v("Fail")]
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "button recycle px-5",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.toggleModal("recycleModal")
                        }
                      }
                    },
                    [_vm._v("Recycle")]
                  )
                ]),
                _vm._v(" "),
                _c("button", {
                  ref: "submitBackgroundVerificationButton",
                  staticClass: "d-none",
                  attrs: {
                    name: "submit_background_verification",
                    value: "submit"
                  }
                }),
                _vm._v(" "),
                _vm.jobApplication.permission_granted &&
                _vm.jobApplication.background_verification_results.length === 0
                  ? _c("div", { staticClass: "d-none cell shrink" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button primary px-5",
                          attrs: {
                            type: "button",
                            disabled: _vm.disabledSubmitBackgroundVerification
                          },
                          on: {
                            click: function($event) {
                              return _vm.toggleModal("confirmModal")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    Submit Background Verification\n                "
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  attrs: { type: "hidden", name: "exclude_matric_check" },
                  domProps: { value: _vm.excludedIds }
                })
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c("recycle-modal", {
            ref: "recycleModal",
            attrs: {
              "job-application": _vm.jobApplication,
              "csrf-token": _vm.csrfToken
            }
          }),
          _vm._v(" "),
          _c("fail-modal", {
            ref: "failModal",
            attrs: { "job-application": _vm.jobApplication },
            on: { submit: _vm.fail }
          }),
          _vm._v(" "),
          _c("modal-confirm", {
            ref: "confirmModal",
            attrs: { message: _vm.modalMessage },
            on: { confirmed: _vm.submitBackgroundVerification }
          }),
          _vm._v(" "),
          _c("move-to-loading-offer-modal", {
            ref: "moveToLoadingOfferModal",
            attrs: {
              "enable-send-to-sage":
                _vm.jobApplication.job.requisition.job_profile
                  .external_requisition_number &&
                _vm.jobApplication.job.requisition.job_profile
                  .sage_job_requisition_id &&
                _vm.jobApplication.job.requisition.job_profile
                  .external_requisition_number !== "" &&
                _vm.jobApplication.job.requisition.job_profile
                  .sage_job_requisition_id !== ""
                  ? true
                  : false
            },
            on: { passSendToSage: _vm.passSendToSage, passOnly: _vm.passOnly }
          })
        ],
        1
      )
    : _c("div", { staticClass: "text-red" }, [
        _vm._v("\n    PERMISSION NOT GRANTED\n")
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell auto" }, [
      _c("label", [_vm._v("Result:")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-490c30a6", { render: render, staticRenderFns: staticRenderFns })
  }
}